import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import { LinkButton } from '@strava/ui/Button';
import styles from './SubscribeFromPreview.styles.scss';
import { I18nPrefix } from '../../shared/SubscriberSummary';

const SubscribeFromPreview = ({ previewEndDate }) => (
  <article className={styles.container}>
    <div className={styles.heading}>
      <h2>
        {I18n.t(
          `${I18nPrefix}.subscription_preview.subscribe_from_preview.title`
        )}
      </h2>
      <LinkButton
        href="/subscribe?origin=account-subscribe-from-preview"
        variant="primary"
        target="blank"
      >
        {I18n.t(
          `${I18nPrefix}.subscription_preview.subscribe_from_preview.cta_subscribe`
        )}
      </LinkButton>
    </div>
    <p className={styles.description}>
      {I18n.t(
        `${I18nPrefix}.subscription_preview.subscribe_from_preview.description`
      )}
    </p>
    <p className={styles.expiration}>
      {I18n.t(
        `${I18nPrefix}.subscription_preview.subscribe_from_preview.expiration`,
        {
          date: previewEndDate
        }
      )}
    </p>
  </article>
);

SubscribeFromPreview.propTypes = {
  previewEndDate: PropTypes.string.isRequired
};

export default SubscribeFromPreview;
